export const text = {
    format: {
        spacesBeforeCapitals: (value, spacerChar) => value.replace(/([A-Z])/g, ` $1`).trim().split(' ').join(spacerChar ? ` ${spacerChar} ` : ' ')
    }
}
export const currency = {
    valid: value => new RegExp(/^\$[1-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/).test(value),
    format: {
        number: value => {
            const num = Number(value.replace(/\D/g, ''))
            return num
        },
        USD: (value, includeCents) => {
            return Number(value.replace(/[^0-9.]/g, '')).toLocaleString('en-US', {
                currency: 'USD',
                style: 'currency',
                maximumFractionDigits: includeCents ? 2 : 0,
                minimumFractionDigits: includeCents ? 2 : 0
            })
        }
    }
}
